import { useMutation } from '@tanstack/react-query'
import { forgotPassword } from '../index'

const useForgotPassword = () =>
  useMutation({
    mutationFn: forgotPassword,
  })

export default useForgotPassword
